import { TestCardBase } from "@app/provider/testData/testCard/TestCardBase";
import {
  ManagedBy,
  PrimaryAction,
  SampleType,
  TestCard,
  TestCardStatus,
} from "@app/provider/testData/types";
import { isHorizonOrPanorama } from "@app/utils/orderHelpers";
import { SimpleOrderWorkflowState } from "@app/provider/order";
import { IntlShape } from "react-intl/src/types";
import { messages } from "@app/provider/testData/messages";

export class ConnectTestCardBase extends TestCardBase {
  protected getDescriptionForSamplesReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    return undefined;
  }

  protected getDescriptionForResultReady(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    return intl.formatMessage(messages.testCardDescResultReadyReview);
  }

  protected getPrimaryActionForUpcomingTest(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return undefined;
  }

  protected getPrimaryActionForTestOrdered(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (
      testCard.simpleOrderWorkflowState &&
      isHorizonOrPanorama(testCard.testType) &&
      testCard.managedBy === ManagedBy.CLINIC &&
      ((testCard.simpleOrderWorkflowState ===
        SimpleOrderWorkflowState.PATIENT_ACCESSED &&
        testCard.isOrderInSignedOrdersTable) ||
        [
          SimpleOrderWorkflowState.PATIENT_SIGNED,
          SimpleOrderWorkflowState.KIT_ORDERED,
          SimpleOrderWorkflowState.COMPLETED,
        ].includes(testCard.simpleOrderWorkflowState))
    ) {
      return undefined;
    }

    if (testCard.nextStatus === TestCardStatus.SAMPLE_RECEIVED) {
      return PrimaryAction.VIEW_TEST_DETAILS;
    }

    if (
      testCard.simpleOrderWorkflowState &&
      [
        SimpleOrderWorkflowState.COMMUNICATION_SENT,
        SimpleOrderWorkflowState.PATIENT_ACCESSED,
      ].includes(testCard.simpleOrderWorkflowState) &&
      !testCard.isOrderInSignedOrdersTable
    ) {
      return PrimaryAction.COMPLETE_ORDER;
    }
  }

  protected getPrimaryActionForKitShipped(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (testCard.sampleType === SampleType.SALIVA) {
      return PrimaryAction.TRACK_KIT_STATUS;
    }
    if (testCard.sampleType === SampleType.BLOOD) {
      return PrimaryAction.SCHEDULE_A_DRAW;
    }
  }
}
